{
  "seo": {
    "title": "School Printables",
    "description": "Download classroom kits and worksheets."
  },
  "title": "Classroom Printables",
  "subtitle": "Download kits, worksheets, and answer keys for your classes.",
  "states": {
    "loading": "Loading printables...",
    "empty": "No printables available yet."
  },
  "actions": {
    "download": "Download"
  }
}
